import { Modal, ModalBody, Spinner } from "reactstrap";
import ErrorMessage from "./ErrorMessage";
import { useState } from "react";
import CrossIcon from "../Icons/CrossIcon";
import CheckIcon from "../Icons/CheckIcon";
import ExclamationIcon from "../Icons/ExclamationIcon";

const ApproveRejectModal = ({
  modal,
  toggle,
  submitHandler,
  isLoading,
  actionType, // "approve", "reject", "shortClose", "hold"
  inputLabel,
  placeholder,
}) => {
  const [reason, setReason] = useState("");
  const [error, setError] = useState("");

  const isHold = actionType === "hold";
  const isShortClose = actionType === "shortClose";
  const isReject = actionType === "reject";
  const isRejectOrShortClose = isReject || isShortClose;
  const requiresReason = isReject || isShortClose || isHold;

  const handleSubmit = () => {
    if (requiresReason) {
      if (!reason.trim()) {
        const defaultLabel = isHold
          ? "Hold Reason"
          : isShortClose
            ? "Short Close Reason"
            : "Reason";
        setError(`${inputLabel || defaultLabel} is required`);
        return;
      }
      submitHandler(reason);
    } else {
      submitHandler();
    }
  };

  const closeHandler = () => {
    setReason("");
    setError("");
    toggle();
  };

  return (
    <Modal isOpen={modal} toggle={closeHandler} centered>
      <ModalBody className="text-center">
        <div className="d-flex flex-column justify-content-center align-items-center gap-4">
          <span
            className={
              isHold
                ? "icon"
                : isRejectOrShortClose
                  ? "icon"
                  : "icon success"
            }
            style={
              isHold
                ? {
                    background: "#fef3c7",
                    boxShadow: "0px 0px 8px 3px #fde68a",
                    color: "#d97706",
                    borderColor: "rgba(217, 119, 6, 0.2)",
                  }
                : {}
            }
          >
            {isHold ? (
              <ExclamationIcon />
            ) : isRejectOrShortClose ? (
              <CrossIcon />
            ) : (
              <CheckIcon />
            )}
          </span>

          {isHold ? (
            <p className="mb-4">Do you really want to put this request on Hold?</p>
          ) : isShortClose ? (
            <p className="mb-4">Do you really want to short close ?</p>
          ) : (
            <p className="mb-4">
              Do you really want to {actionType === "reject" ? "Reject" : "Approve"} this request?
            </p>
          )}

          {requiresReason && (
            <div className="col-12">
              <div className="d-flex flex-column">
                <label htmlFor="reasonInput" className="form-label text-start">
                  {inputLabel ||
                    (isHold
                      ? "Hold Reason"
                      : isShortClose
                        ? "Short Close Reason"
                        : "Reason")}{" "}
                  <span className="text-danger">*</span>
                </label>
                <input
                  type="text"
                  className="form-control w-100"
                  placeholder={
                    placeholder ||
                    (isHold
                      ? "Enter hold reason"
                      : isShortClose
                        ? "Enter short close reason"
                        : "Enter rejection reason")
                  }
                  id="reasonInput"
                  value={reason}
                  onChange={(e) => {
                    setReason(e.target.value);
                    setError("");
                  }}
                />
                <ErrorMessage message={error} />
              </div>
            </div>
          )}

          {/* Buttons */}
          <div className="row m-0 w-100">
            <div className="col-12 col-md-6 ps-0 pe-3">
              <button
                type="button"
                className="btn btn-secondary w-100"
                onClick={closeHandler}
              >
                Cancel
              </button>
            </div>
            <div className="col-12 col-md-6 pe-0 ps-3">
              <button
                className={`btn ${
                  isHold
                    ? "btn-warning text-white"
                    : isRejectOrShortClose
                      ? "btn-danger"
                      : "btn-success"
                } w-100`}
                onClick={handleSubmit}
                disabled={isLoading}
              >
                {isLoading ? (
                  <Spinner />
                ) : isHold ? (
                  "Hold"
                ) : isShortClose ? (
                  "Short Close"
                ) : actionType === "reject" ? (
                  "Reject"
                ) : (
                  "Approve"
                )}
              </button>
            </div>
          </div>
        </div>
      </ModalBody>
    </Modal>
  );
};

export default ApproveRejectModal;

